import SEO from "@/components/SEO";
export default function MentionsLégalesPage() {
  return (
    <div data-testid="mentions-légales-page" className="pt-20 min-h-screen">
      <section className="py-10 md:py-14 px-6 md:px-12 lg:px-24">
        <div className="max-w-3xl mx-auto">
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-warm-grey">Informations légales</span>
          <h1 className="font-heading text-4xl sm:text-5xl tracking-tight text-soft-black mt-4 mb-8">Mentions légales</h1>

          <div className="space-y-12">
            {/* Éditeur */}
            <div>
              <h2 className="font-heading text-xl font-medium tracking-tight text-soft-black mb-4">Éditeur du site</h2>
              <div className="font-body text-sm text-soft-black/70 leading-relaxed space-y-2">
                <p>Le present site est édité par :</p>
                <p className="font-medium text-soft-black">YONO SAS</p>
                <p>Société par actions simplifiée au capital social de 40 000 &euro;</p>
                <p>Siege social : 119 rue d'Aboukir, 75002 Paris, France</p>
                <p>SIRET : 100 373 216 00017</p>
                <p>RCS : Paris</p>
                <p>TVA intracommunautaire : FR38100373216</p>
                <p className="pt-2">Site internet : www.yono-studio.com</p>
                <p>Email : contact@yono-studio.com</p>
                <p>Téléphone : 06 83 58 18 04</p>
              </div>
            </div>

            {/* Directeur */}
            <div className="border-t border-warm-grey/30 pt-8">
              <h2 className="font-heading text-xl font-medium tracking-tight text-soft-black mb-4">Directeur de la publication</h2>
              <p className="font-body text-sm text-soft-black/70 leading-relaxed">
                Le directeur de la publication est Alexis Tessier, président de YONO SAS.
              </p>
            </div>

            {/* Hébergement */}
            <div className="border-t border-warm-grey/30 pt-8">
              <h2 className="font-heading text-xl font-medium tracking-tight text-soft-black mb-4">Hébergement</h2>
              <div className="font-body text-sm text-soft-black/70 leading-relaxed space-y-1">
                <p>Le site est hébergé par :</p>
                <p className="font-medium text-soft-black">OVH SAS</p>
                <p>2 rue Kellermann</p>
                <p>59100 Roubaix</p>
                <p>France</p>
              </div>
            </div>

            {/* Realisation */}
            <div className="border-t border-warm-grey/30 pt-8">
              <h2 className="font-heading text-xl font-medium tracking-tight text-soft-black mb-4">Realisation du site</h2>
              <p className="font-body text-sm text-soft-black/70 leading-relaxed">
                Le site a été conçu et réalisé par YONO SAS.
              </p>
            </div>

            {/* Propriété intellectuelle */}
            <div className="border-t border-warm-grey/30 pt-8">
              <h2 className="font-heading text-xl font-medium tracking-tight text-soft-black mb-4">Propriété intellectuelle</h2>
              <div className="font-body text-sm text-soft-black/70 leading-relaxed space-y-4">
                <p>
                  L'ensemble dès contenus presents sur ce site, notamment les textes, images, photographies, rendus 3D,
                  éléments graphiques, logos, marques, plans et documents, est la propriété exclusive de YONO SAS, sauf mention contraire.
                </p>
                <p>
                  Toute reproduction, représentation, modification, diffusion où exploitation, totale où partielle, de ces éléments,
                  sans autorisation ecrite préalable de YONO SAS, est interdite.
                </p>
              </div>
            </div>

            {/* Donnees personnelles */}
            <div className="border-t border-warm-grey/30 pt-8">
              <h2 className="font-heading text-xl font-medium tracking-tight text-soft-black mb-4">Donnees personnelles</h2>
              <div className="font-body text-sm text-soft-black/70 leading-relaxed space-y-4">
                <p>
                  Les informations collectées via le formulaire de contact du site sont destinees à permettre a YONO SAS
                  de répondre aux demandès recues, d'étudier les projets présentés et, le cas echeant, d'envoyér dès informations
                  où documents en lien avec ces demandes.
                </p>
                <p>
                  Les données susceptibles d'etre collectées sont notamment : nom, prenom, société, adresse email,
                  numéro de téléphone et contenu du message.
                </p>
                <p>Ces données sont conservees pendant une durée maximale de 3 ans a compter du dernier échange.</p>
                <p>
                  Conformement à la réglementation applicable, vous disposez d'un droit d'acces, de rectification,
                  d'opposition, d'effacement et de limitation du traitement de vos données personnelles.
                </p>
                <p>Pour exercer ces droits, vous pouvez écrire a : contact@yono-studio.com</p>
              </div>
            </div>

            {/* Cookies */}
            <div className="border-t border-warm-grey/30 pt-8">
              <h2 className="font-heading text-xl font-medium tracking-tight text-soft-black mb-4">Cookies</h2>
              <div className="font-body text-sm text-soft-black/70 leading-relaxed space-y-4">
                <p>
                  Le site peut utiliser dès cookies nécessaires à son bon fonctionnement ainsi que dès outils de mesure
                  d'audience où de suivi statistique.
                </p>
                <p>
                  Une banniere cookies permet à l'utilisateur d'accepter, de refuser où de parametrer les cookies
                  non nécessaires au fonctionnement du site.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
